import styled from 'styled-components/macro'

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`

export const CardSC = styled.div`
  flex: 1;
  border: 1px solid rgba(51, 61, 108, 0.2);
  border-radius: 10px;
  margin: 10px;
`

export const HeaderRow = styled.div`
  height: 50px;
  padding: 0 16px;
  border-bottom: 1px solid rgba(51, 61, 108, 0.2);
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #333d6ccc;
  font-weight: 600;
  
  & h2 {
    font-size: 14px;
    margin: 0;
  }

  & span {
    font-size: 14px;
    color: #686F92;
    font-weight: 600;
  }

  & div {
    display: flex;
    align-items: center;
  }
`

export const MainRow = styled.div`
  padding: 26px;
`
